<app-help-page mainVideo="introducing-adloop"
               [tutorials]="['api-data-sources', 'metrics-dimensions-per-data-source', 'data-quality', 'data-driven-attribution', 'quick-start', 'cookie-consent']"
               [videos]="['introducing-adloop', 'add-an-automatic-data-source', 'add-an-analytics-data-source', 'custom-data-sources']"></app-help-page>
